import api from './api'

function parseMaybeJson(data) {
  if (typeof data !== 'string') return data
  try {
    return JSON.parse(data)
  } catch {
    return data
  }
}

export const templatesApi = {
  getByApplication: async (applicationId) => {
    const response = await api.get(`/applications/${applicationId}/templates`)
    return response.data
  },

  getById: async (id) => {
    const response = await api.get(`/templates/${id}`)
    return response.data
  },

  create: async (applicationId, data) => {
    const response = await api.post(`/applications/${applicationId}/templates`, data)
    return response.data
  },

  update: async (id, data) => {
    const response = await api.put(`/templates/${id}`, data)
    return response.data
  },

  delete: async (id) => {
    await api.delete(`/templates/${id}`)
  },

  uploadFiles: async (templateId, files) => {
    const formData = new FormData()
    for (const file of files) {
      formData.append('files', file)
    }
    const response = await api.post(`/templates/${templateId}/files`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    })
    return parseMaybeJson(response.data)
  },

  listFiles: async (templateId) => {
    const response = await api.get(`/templates/${templateId}/files`)
    const parsed = parseMaybeJson(response.data)
    if (parsed && typeof parsed === 'object') return parsed
    return { files: [] }
  },

  deleteFile: async (templateId, filename) => {
    const encoded = String(filename || '')
      .split('/')
      .map((p) => encodeURIComponent(p))
      .join('/')
    await api.delete(`/templates/${templateId}/files/${encoded}`)
  },
}
